/**
 * Constantes e utilidades para o módulo de Produção
 */
import { Clock, Play, CheckCircle2, AlertTriangle } from 'lucide-react';

// Configuração de status
export const STATUS_CONFIG = {
  planejado: { label: 'Planejado', color: 'bg-gray-100 text-gray-700 border-gray-300', icon: Clock },
  em_andamento: { label: 'Em Andamento', color: 'bg-blue-100 text-blue-700 border-blue-300', icon: Play },
  concluido: { label: 'Concluído', color: 'bg-green-100 text-green-700 border-green-300', icon: CheckCircle2 },
  atrasado: { label: 'Atrasado', color: 'bg-red-100 text-red-700 border-red-300', icon: AlertTriangle }
};

// Opções de filtro de período
export const FILTER_OPTIONS = {
  semana: { label: 'Esta Semana', days: 7 },
  mensal: { label: 'Este Mês', days: 30 },
  trimestral: { label: 'Trimestre', days: 90 },
  personalizado: { label: 'Personalizado', days: null }
};

// Etapas macro padrão
export const ETAPAS_MACRO_PADRAO = [
  { numero: 1, nome: 'Projeto e Planejamento' },
  { numero: 2, nome: 'Produção e Laminação' },
  { numero: 3, nome: 'Acabamentos' },
  { numero: 4, nome: 'Entrega' }
];

/**
 * Formata data para exibição
 */
export const formatDate = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('pt-BR', { 
    day: '2-digit', 
    month: '2-digit', 
    year: 'numeric' 
  });
};

/**
 * Formata data curta (sem ano)
 */
export const formatDateShort = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('pt-BR', { 
    day: '2-digit', 
    month: '2-digit' 
  });
};

/**
 * Calcula status baseado em datas
 */
export const calculateStatus = (item) => {
  if (item.status === 'concluido') return 'concluido';
  
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  
  const dataFimPrevista = item.data_previsao_fim || item.data_fim;
  if (!dataFimPrevista) return item.status || 'planejado';
  
  const dataFim = new Date(dataFimPrevista);
  dataFim.setHours(0, 0, 0, 0);
  
  if (item.status === 'em_andamento' || item.data_inicio_real) {
    return dataFim < hoje ? 'atrasado' : 'em_andamento';
  }
  
  return item.status || 'planejado';
};

/**
 * Verifica se fase está no período do filtro
 */
export const isFaseNoPeriodo = (fase, startDate, endDate) => {
  const dataInicio = fase.data_previsao_inicio || fase.data_inicio;
  const dataFim = fase.data_previsao_fim || fase.data_fim;
  
  if (!dataInicio && !dataFim) return true;
  
  const faseStart = dataInicio ? new Date(dataInicio) : null;
  const faseEnd = dataFim ? new Date(dataFim) : null;
  
  if (faseStart && faseEnd) {
    return faseStart <= endDate && faseEnd >= startDate;
  }
  if (faseStart) return faseStart <= endDate && faseStart >= startDate;
  if (faseEnd) return faseEnd <= endDate && faseEnd >= startDate;
  
  return true;
};

/**
 * Atualiza datas do filtro baseado no tipo
 */
export const getFilterDates = (filter) => {
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  
  let start = new Date(hoje);
  let end = new Date(hoje);
  
  switch (filter) {
    case 'semana':
      start.setDate(hoje.getDate() - hoje.getDay());
      end.setDate(start.getDate() + 6);
      break;
    case 'mensal':
      start.setDate(1);
      end.setMonth(end.getMonth() + 1);
      end.setDate(0);
      break;
    case 'trimestral':
      const quarter = Math.floor(hoje.getMonth() / 3);
      start.setMonth(quarter * 3);
      start.setDate(1);
      end.setMonth(quarter * 3 + 3);
      end.setDate(0);
      break;
    default:
      end.setDate(hoje.getDate() + 30);
  }
  
  return { start, end };
};

/**
 * Calcula indicadores das fases
 */
export const calcularIndicadores = (fases) => {
  let totalFases = 0;
  let emAndamento = 0;
  let concluidas = 0;
  let atrasadas = 0;
  let pendentes = 0;
  
  fases.forEach(fase => {
    totalFases++;
    const status = calculateStatus(fase);
    if (status === 'em_andamento') emAndamento++;
    else if (status === 'concluido') concluidas++;
    else if (status === 'atrasado') atrasadas++;
    else pendentes++;
  });
  
  return { totalFases, emAndamento, concluidas, atrasadas, pendentes };
};
